// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/Style/main.scss
// module id = 8283
// module chunks = 2